module.exports = __webpack_public_path__ + "static/green-wave-4edcd1cca3c101b2ee2f5e0d587f38a7.png";